import FlowInterface from "./flow-interface";
import { noopPromise } from "@/utils";
import { generateOnSessionSignature } from '@/apis/payment';

export default class Flow extends FlowInterface {
    apmParams() { }
    async beforeContinue() { return noopPromise() }
    async beforeUpdate() { return noopPromise() }
    async beforeSubmit() { return noopPromise() }
    async preparePaymentData(params) {
      return generateOnSessionSignature(params);
    }
}
